import { Injectable } from '@angular/core';

import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

import { formatDate } from '@lib/commons/util-functions/format-date.function';
import { parseDate } from '@lib/commons/util-functions/parse-date.function';

/** Sentinel token for the text-input format so the adapter routes it through `formatDate`. */
const LILO_DATE_INPUT = 'lilo-date-input';

/**
 * Date formats for the shared datepicker. The text input is rendered/parsed via the commons
 * date helpers; calendar header/a11y labels keep the native locale-aware formatting.
 */
export const LILO_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: LILO_DATE_INPUT },
  display: {
    dateInput: LILO_DATE_INPUT,
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

/**
 * Native date adapter that displays the selected date with `formatDate` and parses typed input
 * with `parseDate`, so every shared datepicker shows and reads dates the same way — whether the
 * user picks from the calendar or types by hand. Scoped to the datepicker component; the app-wide
 * adapter is left untouched.
 */
@Injectable()
export class LiloDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: object): string {
    if ((displayFormat as unknown) === LILO_DATE_INPUT) return formatDate(date);
    return super.format(date, displayFormat);
  }

  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value !== 'string') return super.parse(value, parseFormat);
    else if (!value.trim()) return null;
    else return parseDate(value) ?? new Date(NaN);
  }
}
